/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type messaging_CreateBroadcastRequest = {
    allow_comments?: boolean;
    message: string;
    subject?: string;
    target_ids: Array<string>;
    target_type: messaging_CreateBroadcastRequest.target_type;
};
export namespace messaging_CreateBroadcastRequest {
    export enum target_type {
        GROUP = 'group',
        CHILDCARE = 'childcare',
    }
}

